import { request } from '@/api/client';
import type { InvoiceListResponse, InvoiceDownloadResponse } from '@/types/payment';

/** Per-echo earnings rollup: credits earned/withdrawn/available + monetary totals. */
export interface EchoEarningsResponse {
  echo_id: string;
  total_credits_earned: number;
  total_credits_withdrawn: number;
  pending_credits: number;
  available_credits: number;
  total_amount_earned: number;
  total_amount_withdrawn: number;
  total_interactions: number;
  created_at: string;
  updated_at: string;
}

/** Creator payouts — per-echo earnings, invoice listing, signed download URLs. */
export const payoutsService = {
  getEchoEarnings: (echoId: string): Promise<EchoEarningsResponse> =>
    request<EchoEarningsResponse>(`/payouts/earnings/${echoId}`, {
      method: 'GET',
      auth: true,
    }),

  getInvoices: (params: {
    year?: number;
    month?: number;
    offset?: number;
    limit?: number;
  }): Promise<InvoiceListResponse> => {
    const searchParams = new URLSearchParams();
    if (params.year) searchParams.set('year', String(params.year));
    if (params.month) searchParams.set('month', String(params.month));
    if (params.offset !== undefined) searchParams.set('offset', String(params.offset));
    if (params.limit !== undefined) searchParams.set('limit', String(params.limit));
    const qs = searchParams.toString();
    return request<InvoiceListResponse>(`/payouts/invoices${qs ? `?${qs}` : ''}`, {
      method: 'GET',
      auth: true,
    });
  },

  getInvoiceDownloadUrl: (
    payoutId: string,
    type: 'revenue' | 'platform_fee'
  ): Promise<InvoiceDownloadResponse> =>
    request<InvoiceDownloadResponse>(
      `/payouts/invoices/${payoutId}/download?invoice_type=${type}`,
      { method: 'GET', auth: true }
    ),
};
